import CardSystem from '../../Card/CardSystem';
import Animator from 'Prototype/Animator';
import AnimationClip from '../AnimationClip';
import { ConcatIterators, PlayAnimation } from '../AnimationHelper';
import { CardDestroy } from './CardDestroy';
import { GoldCardData, ICardStateData, ValueCardData } from 'State/Card/ICardState';
import Interactable from 'Component/Interactable';
import { AudioTrackType } from 'System/Audio/AudioClip';
import { PlaySound } from 'System/Audio/AudioHelper';
import StreakBar from 'Prototype/UI/Level/StreakBar';
import CardStateHelper from '../../../State/Card/CardStateHelper';
import CardComponent from 'Component/Level/Card';

interface IRemoveCardPreBoosterMeta {
    system: CardSystem;
    cardsData: ICardStateData[];
}
export class RemoveCardsPreBooster extends AnimationClip<
    IRemoveCardPreBoosterMeta
> {
    public *execute(
        animator: Animator,
        meta: IRemoveCardPreBoosterMeta
    ): IterableIterator<number> {
        const { system, cardsData } = meta;

        yield* ConcatIterators(cardsData.map((cardData, index) => removeCard(cardData, index)));
        return;

        function *removeCard(cardData: ICardStateData, index: number): IterableIterator<number> {
            const card = system.getCardByID(cardData.id);
            animator.addChild(card);
            card.getComponent(Interactable).enabled = false;

            while (card.getComponent(CardComponent).flipping) yield;

            PlaySound(`remove_card_booster_0${index + 1}`);

            card.hideAndDestroyModifiers();

            yield* PlayAnimation(
                new CardDestroy(card, {
                    system,
                    suit: CardStateHelper.getCardSuit(cardData as ValueCardData | GoldCardData),
                })
            );

            StreakBar.instance.update();
        }
    }
}
